// ERRORS-1 Part B: "Reported as #123" — the latest report the viewer filed about this
// recording, so they know it landed and don't file it twice. Renders nothing when bug reports
// are off, in mock mode, or when there is no report.
import { useBugReportsForRecording } from '../lib/supportQueries';

export function BugReportStatus({ recordingId }: { recordingId: string }) {
  const { data } = useBugReportsForRecording(recordingId);
  const latest = data?.items[0];
  if (!latest) return null;
  if (latest.status === 'delivered' && latest.github_issue_number != null) {
    return (
      <p className="muted" role="status">
        Reported as{' '}
        {latest.github_issue_url ? (
          <a href={latest.github_issue_url} target="_blank" rel="noreferrer">
            #{latest.github_issue_number}
          </a>
        ) : (
          `#${latest.github_issue_number}`
        )}
        .
      </p>
    );
  }
  return (
    <p className="muted" role="status">
      {latest.status === 'failed'
        ? 'Your report was saved, but filing it for the team failed — an admin has been left the details.'
        : 'Your report was received and will be filed for the team shortly.'}
    </p>
  );
}
